export default {
  APP_ID: "124024574287414",
  APP_NAME: "Instagram",
  APP_VERSION: "123.1.0.26.115",
  APP_BUNDLE_VERSION: "26.0.0.18.87 (83603364)",
  API_HOST: "https://i.instagram.com",
  SECRET_KEY_1:
    "D1IOUwNQD1ACVAMCAFdVAQAHB1AFAgQDBgEPUgIHBFcHVwFSAQMDVQ9TUgdXDwIEVFIDBg4CAA8EAFMEVwRTUg==",
  SECRET_KEY_2:
    "ZThkOWk6ZTpoPmloaj0/a2ptbTpvaG5pbGtlOGhtbj1tPWs4a2lpP2U5OG09ZWhuPjhpbGRoamVuajluPW45OA==",
  CONNECTION_SPEED: "-1kbps",
  APP_BUILD_ID: "190542906",
  CAPABILITIES: "36r/FwM",
  FACEBOOK_ID: "124024574287414",
  VERSION_ID:
    "34751ed5be6fbaacccb5e967fd6ca873ba78ccded38e3c1df333e62210f2ec2f",
  IG_SIG_KEY_VERSION: "5"
};
